import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[FlickHub] App is ready for offline use');
  },
  onUpdate: (registration) => {
    console.log('[FlickHub] New version available! Refresh to update.');
    // Dispatch custom event that can be caught by components
    window.dispatchEvent(new CustomEvent('swUpdate', { detail: registration }));
  },
});
